import React, {Component} from 'react';
import PropTypes from 'prop-types';
import Loading from './Loading';
import AppearanceContext from '../context/AppearanceContext';

const LoadableHOC = (C) => {
  class LoadableComponent extends Component {
    render() {
      const loadingParams = {
        loadingWrapClass: this.props.loadingWrapClass,
      };

      return (
<AppearanceContext.Consumer>
        {data => (data.isLoading || data.isSubmitLoading) ?
          <Loading {...loadingParams} /> : <C {...this.props} />}
</AppearanceContext.Consumer>
      );
    }
  }

  LoadableComponent.PropTypes = {
    loadingWrapClass:PropTypes.string,
  };

  return LoadableComponent;
};

export default LoadableHOC;
